var _g, _circle, _circle2, _path, _path2, _path3, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataV1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 632.17383,
    viewBox: "0 0 647.63626 632.17383",
    width: 647.63626,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-276.18187 -133.91309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m687.3279 276.08691h-174.50977a15.01828 15.01828 0 0 0 -15 15v387.85l-2 .61005-42.81006 13.11a8.00676 8.00676 0 0 1 -9.98974-5.31l-127.34033-415.95005a8.00313 8.00313 0 0 1 5.31006-9.99l65.97022-20.2 191.25-58.54 65.96972-20.2a7.98927 7.98927 0 0 1 9.99024 5.3l32.5498 106.32z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m725.408 274.08691-39.23-128.14a16.99368 16.99368 0 0 0 -21.23-11.28l-92.75 28.39-191.23973 58.55002-92.75 28.4a17.0152 17.0152 0 0 0 -11.28028 21.23l134.08008 437.93a17.02661 17.02661 0 0 0 16.26026 12.03 16.78926 16.78926 0 0 0 4.96972-.75l63.58008-19.46 2-.62v-2.09l-2 .61-64.16992 19.65a15.01489 15.01489 0 0 1 -18.73-9.95l-134.06983-437.94a14.97935 14.97935 0 0 1 9.94971-18.73l92.75-28.4 191.24024-58.54 92.75-28.4a15.15551 15.15551 0 0 1 4.40966-.66 15.01461 15.01461 0 0 1 14.32032 10.61l39.0498 127.56.62012 2h2.08008z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.86279 261.73389a9.0157 9.0157 0 0 1 -8.61133-6.3667l-12.88037-42.07178a8.99884 8.99884 0 0 1 5.9712-11.24023l175.939-53.86377a9.00867 9.00867 0 0 1 11.24072 5.9707l12.88037 42.07227a9.01029 9.01029 0 0 1 -5.9707 11.24072l-175.93949 53.86377a8.976 8.976 0 0 1 -2.6294.39502z",
    fill: "#e0e0e0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190.15351,
    cy: 24.95465,
    fill: "#e0e0e0",
    r: 20
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.15351,
    cy: 24.95465,
    fill: "#fff",
    r: 12.66462
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m878.81836 716.08691h-338a8.50981 8.50981 0 0 1 -8.5-8.5v-405a8.50951 8.50951 0 0 1 8.5-8.5h338a8.50982 8.50982 0 0 1 8.5 8.5v405a8.51013 8.51013 0 0 1 -8.5 8.5z",
    fill: "#e6e6e6",
    transform: "translate(-276.18187 -133.91309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m723.31813 274.08691h-210.5a17.02411 17.02411 0 0 0 -17 17v407.8l2-.61v-407.19a15.01828 15.01828 0 0 1 15-15h211.12012zm183.5 0h-394a17.02411 17.02411 0 0 0 -17 17v458a17.0241 17.0241 0 0 0 17 17h394a17.0241 17.0241 0 0 0 17-17v-458a17.02411 17.02411 0 0 0 -17-17zm15 475a15.01828 15.01828 0 0 1 -15 15h-394a15.01828 15.01828 0 0 1 -15-15v-458a15.01828 15.01828 0 0 1 15-15h394a15.01828 15.01828 0 0 1 15 15z",
    fill: "#3f3d56",
    transform: "translate(-276.18187 -133.91309)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m801.81836 318.08691h-184a9.01015 9.01015 0 0 1 -9-9v-44a9.01016 9.01016 0 0 1 9-9h184a9.01016 9.01016 0 0 1 9 9v44a9.01015 9.01015 0 0 1 -9 9z",
    fill: "#e0e0e0",
    transform: "translate(-276.18187 -133.91309)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.63626,
    cy: 105.17383,
    fill: "#e0e0e0",
    r: 20
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 433.63626,
    cy: 105.17383,
    fill: "#fff",
    r: 12.18187
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataV1);
export default __webpack_public_path__ + "static/media/no_data_v1.5f873249827b3ef06faa7a1405d0f8a5.svg";
export { ForwardRef as ReactComponent };